export enum SurveyId {
  LIVE_CLASS_SURVEY_NEW = "LIVE_CLASS_SURVEY_NEW",
  AI_FEEDBACK_SURVEY = "AI_FEEDBACK_SURVEY"
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/survey-id.enum.ts